const formControlLabelFormParamUser = {
  admin: 'Administrador',
  analyst: 'Analista',
  contractor: 'Empresa Terceira'
};

export default formControlLabelFormParamUser;
